import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './GeneratedAppIcon.scss'

import { svgAsPngUri } from 'save-svg-as-png'
import tinycolor from 'tinycolor2'
import { shuffle } from 'lodash'

class GeneratedAppIcon extends React.Component {
	constructor(props) {
		super(props)
		const themeColor = this.props.themeColor || '#5b5b87'
		const analogousColors = shuffle(tinycolor(themeColor).analogous())

		this.state = {
			scale1: this._random(),
			scale2: this._random(),
			scale3: this._random(),
			themeColors: analogousColors,
			loading: false
		}
	}
	_getRandomIntInclusive = (min, max) => {
		min = Math.ceil(min)
		max = Math.floor(max)
		return Math.floor(Math.random() * (max - min + 1)) + min
	}
	_random = () => {
		return Math.floor(Math.random() * 80 + 50) / 100
	}
	_dataURItoBlob = dataURI => {
		var byteString = atob(dataURI.split(',')[1])
		var ab = new ArrayBuffer(byteString.length)
		var ia = new Uint8Array(ab)
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i)
		}
		return new Blob([ab], { type: 'image/png' })
	}
	_handleSetImageData = imageData => {
		const { setImageData } = this.props
		setImageData(imageData)
	}
	_handleSetImageFile = imageData => {
		const { setImageFile } = this.props
		setImageFile(this._dataURItoBlob(imageData))
	}
	_generateNewIcon = e => {
		this.setState({
			scale1: this._random(),
			scale2: this._random(),
			scale3: this._random()
		})

		svgAsPngUri(this.svgRef, {}, uri => {
			this._handleSetImageData(uri)
			this._handleSetImageFile(uri)
		})
	}
	render() {
		return (
			<svg
				viewBox="0 0 240 240"
				style={{
					height: '0px',
					width: '0px'
				}}
				onClick={this.handleClick}
				ref={ref => (this.svgRef = ref)}
			>
				<g styleName="isolates">
					<rect
						fill={this.state.themeColors[3]}
						x="0"
						y="0"
						width="240"
						height="240"
						styleName="isolates"
						opacity="1"
					/>
					<polygon
						fill="#ffffff"
						styleName="isolates"
						points="120 240 240 0 0 0"
						opacity="0.2"
						transform={`rotate(${360 * this.state.scale2}, 80, 80)`}
					/>
					<g
						transform={`rotate(${360 *
							this.state.scale1}, 120, 120)`}
					>
						<polygon
							fill="#ffffff"
							transform={`translate(${30 *
								this.state.scale1},${80 * this.state.scale2})`}
							points="65.34 190.25 36.56 140.4 65.34 90.56 122.89 90.56 151.67 140.4 122.89 190.25 65.34 190.25"
						/>
						<circle
							fill={tinycolor(this.state.themeColors[1])
								.tetrad()[1]
								.toHexString()}
							className={styles.multiply}
							opacity="0.9"
							cx="170"
							cy="150"
							r={20 * this.state.scale2}
						/>
						<circle
							fill="#ffffff"
							cx="80"
							cy="90"
							r={30 * this.state.scale3 - 3}
						/>
						<polygon
							fill="none"
							strokeWidth="6"
							stroke={this.state.themeColors[3]}
							className={styles.multiply}
							transform={`translate(${25 *
								this.state.scale1},${20 * this.state.scale2})`}
							points="57.26 179.86 28.48 130.02 57.26 80.17 114.81 80.17 143.59 130.02 114.81 179.86 57.26 179.86"
						/>
					</g>
				</g>
			</svg>
		)
	}
}

export default CSSModules(GeneratedAppIcon, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/GeneratedAppIcon/GeneratedAppIcon.js